import { THEME } from 'components/theme'

export default {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    whiteSpace: 'nowrap',
    paddingBottom: 10
  },
  filter: {
    margin: '2px 5px',
    fontSize: '14px',
    lineHeight: 1.36,
    letterSpacing: '0.25px',
    color: THEME.brandDarkerGrey
  },
  filterActive: {
    color: THEME.infoGrey
  },
  customDateActive: {
    border: 'solid 1px #24ad4b !important',
    backgroundColor: `${THEME.brandLightGreen} !important`
  },
  datePicker: {
    padding: '6px 12px',
    borderRadius: 4,
    border: `1px solid ${THEME.brandLightGrey}`,
    backgroundColor: THEME.brandLightestGrey,
    userSelect: 'none',
    cursor: 'pointer',
    outline: 'none',
    width: 100
  },

  inputContainer: {
    position: 'relative'
  },
  adornElement: {
    display: 'inline-flex',
    width: 24,
    height: '100%',
    textAlign: 'center',
    position: 'absolute',
    lineHeight: '4em',
    alignItems: 'center',
    top: 0,
    right: 10
  }
}
